import { render, staticRenderFns } from "./ClientAddUpdate.vue?vue&type=template&id=252178b4&"
import script from "./ClientAddUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports